import React from 'react';
import tpl from '../templates/e-receipt';
import BaseNewCardView from '../../../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    shouldFetchData() {
        return false;
    }

    static displayName = 'Gov.eReceipt';
}
